<template>
    <DataTable
        ref="dt"
        class="app-datatable data-table-expandable"
        :filterButtonProps="{ filter: { class: 'app-dt-filter-btn' } }"
        v-model:expandedRows="expandedRows"
        v-model:filters="filters"
        v-model:editingRows="editingRows"
        editMode="row"
        @row-edit-save="onRowEditSave"
        :pt="{
				table: { style: 'min-width: 50rem' },
				column: {
						bodycell: ({ state }) => ({
								style:  state['d_editing']&&'padding-top: 0.75rem; padding-bottom: 0.75rem'
						})
				}
		}"
        :value="displayedRows"
        dataKey="id"
        filterDisplay="menu"
        :loading="loading"
        scrollable
        :scrollHeight="tableScrollHeight"
        :paginator="paginatorEnabled"
        :rows="paginatorRows"
        stateStorage="session"
        :stateKey="modulo+'-session'"
        :globalFilterFields="globalfilters"
    >

        <template #header>
            <div class="flex justify-between container-button-e-search">
                <div class="icon-action-datatable-container">
                    <Button class="icon-action-datatable" text icon="pi pi-filter-slash" @click="clearFilter()"/>
                    <Button class="icon-action-datatable" text icon="pi pi-angle-double-down" @click="expandAll"/>
                    <Button class="icon-action-datatable" text icon="pi pi-angle-double-up" @click="collapseAll"/>
                    <Button v-if="add_action" as="a" class="icon-action-datatable" text icon="pi pi-plus" :href="add_action"/>
                </div>
                <IconField class="ricerca-search">
                    <InputText v-model="filters['global'].value" :placeholder="$root.trans.cerca" class="input-cerca"/>
                    <InputIcon>
                        <i class="pi pi-search"/>
                    </InputIcon>
                </IconField>
            </div>
        </template>


        <Column expander class="icona" style="width: 1px; white-space: nowrap;"/>
        <template v-if="actions && Object.keys(actions).length > 0">
            <Column :exportable="false" class="icona" style="width: 1px; white-space: nowrap;">
                <template #body="slotProps">
                    <div class="row-actions-inline">
                        <template v-for="(action, key) in actions">
                            <template
                                v-if="(key !== 'elimina' && key !== 'aggiungiriga'  )  &&  (!action.condizione || (action.condizione === true && slotProps.data[action.condizione_key] === action.condizione_value))">
                                <a :href="generateUrl(action, slotProps.data)"
                                   @click.prevent="handleActionClick(action, slotProps.data)"
                                   class="mx-1 p-button p-button-icon-only p-button-secondary p-button-rounded p-button-text">
                                    <i v-if="action.icona" :class="'pi '+action.icona"></i>
                                    <img v-if="action.img" :src="action.img" :class="action.class"/>
                                </a>
                            </template>
                            <template v-if="key === 'elimina'">
                                <a @click="rimuoviRiga(action , slotProps.data ,0 )"
                                   class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  ">
                                    <i :class="'pi '+action.icona"></i>
                                </a>
                            </template>
                            <template v-if="key === 'aggiungiriga'">
                                <a @click="aggiungiRiga(slotProps.data )"
                                   class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  ">
                                    <i :class="'pi '+action.icona"></i>
                                </a>
                            </template>
                        </template>
                    </div>
                </template>
            </Column>
        </template>
        <Column v-if="isedit" :rowEditor="true" bodyStyle="text-align:center" class="icona" style="width: 1px; white-space: nowrap;"></Column>
        <Column v-for="column in visibleColumns"
                :key="column.name"
                :field="column.name"
                :header="column.title"
                sortable
                :filter="true"
                class="testo">
            <template #sorticon="slotProps">
                <span :class="['app-dt-icon', slotProps.sorted ? (slotProps.sortOrder === 1 ? 'pi pi-sort-amount-up-alt' : 'pi pi-sort-amount-down-alt') : 'pi pi-sort-alt']"></span>
            </template>
            <template #filtericon>
                <span class="pi pi-filter app-dt-icon"></span>
            </template>
            <template v-if="isedit" #editor="{ data, field }">
                <template v-if="column.formato === 'select' ">
                    <Select v-model="data[field]" :options="column.options" optionLabel="nome" optionValue="id"
                            :placeholder="$root.trans.option_selezionare" fluid>
                        <template #option="slotProps">
                            <div> {{ slotProps.option.nome }}</div>
                        </template>
                    </Select>
                </template>
                <template v-else-if="column.formato === 'select-multipla' ">
                    <MultiSelect v-model="data[field]" :options="column.options" optionLabel="nome" optionValue="id"
                                 :placeholder="$root.trans.option_selezionare" fluid filter>
                        <template #option="slotProps">
                            <div> {{ slotProps.option.nome }}</div>
                        </template>
                    </MultiSelect>
                </template>
                <template v-else>
                    <InputText v-model="data[field]" fluid/>
                </template>
            </template>
            <template #body="{data}">
                <template v-if="column.formato === 'data'">
                    {{ data[column.name] != '' && data[column.name] != null ? formatDate(data[column.name]) : '' }}
                </template>
                <template v-else-if="column.formato === 'dataora'">
                    {{ data[column.name] != '' && data[column.name] != null ? formatDateTime(data[column.name]) : '' }}
                </template>
                <template v-else-if="column.formato === 'ora_esadecimale'">
                    {{ formatTimeHexadecimal(data[column.name]) }}
                </template>
                <template v-else-if="column.formato === 'ora'">
                    {{ formatTime(data[column.name]) }}
                </template>
                <template v-else-if="column.formato === 'num_intero'">
                    {{ formatNumberInt(data[column.name]) }}
                </template>
                <template v-else-if="column.formato === 'num_decimale'">
                    {{ formatNumberDecimal(data[column.name]) }}
                </template>
                <template v-else-if="column.formato === 'prezzo'">
                    {{ formatCurrency(data[column.name]) }}
                </template>
                <template v-else-if="column.formato === 'colore'">
                    <span v-html="formatColor(data[column.name])"></span>
                </template>
                <template v-else-if="column.formato === 'componenti'">
                    <template v-for="componente in data[column.name]">
                        <component
                            :is="component(componente)"
                            v-bind="componentProps(componente)"
                        />
                    </template>
                </template>
                <template v-else-if="column.formato === 'select-multipla'">
                    {{ formatMultiSelectId(data, column) }}
                </template>
                <template v-else-if="column.formato === 'email'">
                    <span v-html="formatEmail(data[column.name])"></span>
                </template>
                <template v-else-if="column.formato === 'luogo'">
                    <span v-html="formatLocation(data[coordinate] , data[column.name] )"></span>
                </template>
                <template v-else-if="column.formato === 'link'">
                    <span v-html="formatLink( data[column.name] )"></span>
                </template>
                <template v-else>
                    {{ data[column.name] }}
                </template>
            </template>
            <template #filter="{ filterModel }">
                <template v-if="column.formato === 'data'">
                    <DatePicker v-model="filterModel.value" dateFormat="yyyy/mm/dd" placeholder="mm/dd/yyyy"/>
                </template>
                <template v-else-if="column.formato === 'dataora'">
                    <DatePicker v-model="filterModel.value" dateFormat="yyyy/mm/dd hh:mm" placeholder="mm/dd/yyyy hh:mm" showTime
                                hourFormat="24"/>
                </template>
                <template v-else-if="column.formato === 'ora_esadecimale'">
                    <DatePicker v-model="filterModel.value" dateFormat="hh:mm" placeholder="hh:mm" timeOnly hourFormat="24"/>
                </template>
                <template v-else-if="column.formato === 'ora'">
                    <DatePicker v-model="filterModel.value" dateFormat="hh:mm" placeholder="hh:mm" timeOnly hourFormat="24"/>
                </template>
                <template v-else-if="column.formato === 'colore'">
                    <ColorPicker v-model="filterModel.value"/>
                </template>
                <template v-else>
                    <InputText v-model="filterModel.value" type="text" :placeholder="column.title"/>
                </template>
            </template>
        </Column>
        <template #expansion="slotProps">
            <DataTable class="app-datatable" :value="getDynamicProperty(slotProps.data, subrows)"
                       v-model:editingRows="editingRows"
                       editMode="row"
                       @row-edit-save="(event) => onSubRowEditSave(event, slotProps.data.id)"
            >
                <Column v-if="isedit" :rowEditor="true" style="width: 1px; white-space: nowrap;"
                        bodyStyle="text-align:center" class="icona"></Column>
                <template v-if="Object.keys(sub_actions).length > 0">
                    <Column :exportable="false" style="width: 1px; white-space: nowrap;" class="icona">
                        <template #body="slotProps">
                            <div class="row-actions-inline">
                                <template v-for="(action, key) in sub_actions">
                                    <template
                                        v-if="(key !== 'elimina' && key !== 'aggiungiriga'  )  &&  (!action.condizione || (action.condizione === true && slotProps.data[action.condizione_key] === action.condizione_value))">
                                        <a :href="generateUrl(action, slotProps.data)"
                                           class="mx-1 p-button p-button-icon-only p-button-secondary p-button-rounded p-button-text">
                                            <i v-if="action.icona" :class="'pi '+action.icona"></i>
                                            <img v-if="action.img" :src="action.img" :class="action.class"/>
                                        </a>
                                    </template>
                                    <template v-if="key === 'elimina'">
                                        <a @click="rimuoviRiga(action , slotProps.data , 1)"
                                           class="mx-1 p-button p-button-icon-only p-button-secondary p-button-rounded p-button-text">
                                            <i :class="'pi '+action.icona"></i>
                                        </a>
                                    </template>
                                </template>
                            </div>
                        </template>
                    </Column>
                </template>
                <Column v-for="column in visibleSubColumns"
                        :key="column.name"
                        :field="column.name"
                        :header="column.title"
                        class="testo"
                        sortable>
                    <template #sorticon="slotProps">
                        <span :class="['app-dt-icon', slotProps.sorted ? (slotProps.sortOrder === 1 ? 'pi pi-sort-amount-up-alt' : 'pi pi-sort-amount-down-alt') : 'pi pi-sort-alt']"></span>
                    </template>
                    <template v-if="isedit" #editor="{ data, field }">
                        <template v-if="column.formato === 'select' ">
                            <Select v-model="data[field]" :options="column.options" optionLabel="nome" optionValue="id"
                                    :placeholder="$root.trans.option_selezionare" fluid>
                                <template #option="slotProps">
                                    <div> {{ slotProps.option.nome }}</div>
                                </template>
                            </Select>
                        </template>
                        <template v-else>
                            <InputText v-model="data[field]" fluid/>
                        </template>
                    </template>
                    <template #body="{data}">
                        <template v-if="column.formato === 'data'">
                            {{ data[column.name] != '' && data[column.name] != null ? formatDate(data[column.name]) : '' }}
                        </template>
                        <template v-else-if="column.formato === 'dataora'">
                            {{ data[column.name] != '' && data[column.name] != null ? formatDateTime(data[column.name]) : '' }}
                        </template>
                        <template v-else-if="column.formato === 'ora'">
                            {{ formatTime(data[column.name]) }}
                        </template>
                        <template v-else-if="column.formato === 'num_intero'">
                            {{ formatNumberInt(data[column.name]) }}
                        </template>
                        <template v-else-if="column.formato === 'num_decimale'">
                            {{ formatNumberDecimal(data[column.name]) }}
                        </template>
                        <template v-else-if="column.formato === 'prezzo'">
                            {{ formatCurrency(data[column.name]) }}
                        </template>
                        <template v-else-if="column.formato === 'colore'">
                            <span v-html="formatColor(data[column.name])"></span>
                        </template>
                        <template v-else-if="column.formato === 'select'">
                            {{ formatSelectId(data, column) }}
                        </template>
                        <template v-else>
                            {{ data[column.name] }}
                        </template>
                    </template>
                    <template #filter="{ filterModel }">
                        <template v-if="column.formato === 'data'">
                            <DatePicker v-model="filterModel.value" dateFormat="yyyy/mm/dd" placeholder="mm/dd/yyyy"/>
                        </template>
                        <template v-else-if="column.formato === 'dataora'">
                            <DatePicker v-model="filterModel.value" dateFormat="yyyy/mm/dd hh:mm" placeholder="mm/dd/yyyy hh:mm"
                                        showTime
                                        hourFormat="24"/>
                        </template>
                        <template v-else-if="column.formato === 'ora'">
                            <DatePicker v-model="filterModel.value" dateFormat="hh:mm" placeholder="hh:mm" timeOnly hourFormat="24"/>
                        </template>
                        <template v-else-if="column.formato === 'colore'">
                            <ColorPicker v-model="filterModel.value"/>
                        </template>
                        <template v-else>
                            <InputText v-model="filterModel.value" type="text" :placeholder="column.title"/>
                        </template>
                    </template>
                </Column>
            </DataTable>
        </template>
        <template v-if="is_lazy && loadingMore" #footer>
            <div class="flex justify-center p-3">
                <i class="pi pi-spin pi-spinner"></i>
            </div>
        </template>
    </DataTable>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import MultiSelect from 'primevue/multiselect';
import Tag from 'primevue/tag';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import axios from 'axios';
import {FilterMatchMode, FilterOperator} from '@primevue/core/api';
import {resolveComponent, toRaw} from "vue";
import Select from "primevue/select";
import ColorPicker from "primevue/colorpicker";


export default {
    name: 'DatatableAdvanceExpandable',
    props: {
        modulo: {
            type: String,
            required: true
        },
        colonne: {
            type: Array,
            required: true
        },
        sub_colonne: {
            type: Array,
            required: true
        },
        route_righe: {
            type: String,
            required: true
        },
        sub_righe: {
            type: String,
            required: true
        },
        sub_azioni: {
            type: Object,
            required: true
        },
        azioni: {
            type: Object,
            required: true
        },
        mess_vuoto: {
            type: String,
            required: false
        },
        mess_caricamento: {
            type: String,
            required: false
        },
        route_params: {
            type: Object,
            required: false
        },
        is_edit: {
            type: String,
            default: false
        },
        add_action: {
            type: String,
            default: null
        },
        use_paginator: {
            type: Boolean,
            default: true
        },
        paginator_rows: {
            type: Number,
            default: 20
        },
        paginator_threshold: {
            type: Number,
            default: null
        },
        is_lazy: {
            type: Boolean,
            default: false
        },
        lazy_rows: {
            type: Number,
            default: 10
        },
        lazy_scroll_height: {
            type: String,
            default: '70vh'
        }
    },
    components: {ColorPicker, Select, DataTable, Column, Button, InputText, IconField, InputIcon, Tag, MultiSelect},
    data() {
        return {
            filters: [],
            loading: true,
            rows: [],
            dataKey: [],
            columns: this.colonne,
            actions: this.azioni,
            sub_columns: this.sub_colonne,
            sub_actions: this.sub_azioni,
            subrows: this.sub_righe,
            isedit: this.is_edit,
            expandedRows: [],
            globalfilters: [],
            subExpandedRows: {},
            editingRows: [],
            displayedCount: 0,
            loadingMore: false,
            _scrollContainer: null,
        };
    },
    computed: {
        displayedRows() {
            if (!this.is_lazy) {
                return this.rows;
            }

            return this.rows.slice(0, this.displayedCount);
        },
        visibleColumns() {
            return this.columns.filter(column => column.formato !== 'hidden');
        },
        visibleSubColumns() {
            return this.sub_columns.filter(column => column.formato !== 'hidden');
        },
        paginatorRows() {
            return this.paginator_rows || 20;
        },
        tableScrollHeight() {
            return this.is_lazy ? this.lazy_scroll_height : null;
        },
        paginatorEnabled() {
            if (this.is_lazy) return false;
            if (!this.use_paginator) return false;
            if (this.paginator_threshold === null) return true;
            return this.rows.length > this.paginator_threshold;
        }
    },
    async beforeCreate() {
        const righe = await axios.get(route(this.route_righe, this.route_params));
        if (righe.status === 200) {
            this.rows = righe.data;
        } else {
            this.rows = [];
        }
    },
    async created() {
        this.initFilters();
        this.globalfilters = this.columns.map(c => c.filtro ? c.name : null).filter(v => v);
        const {data} = await axios.get(route(this.route_righe, this.route_params));
        this.rows = data;
        this.displayedCount = this.is_lazy ? this.lazy_rows : this.rows.length;
        this.loading = false;

    },
    async mounted() {
        this.loading = true;
        axios.get(route(this.route_righe, this.route_params))
            .then(res => {
                this.rows = res.data;
                this.displayedCount = this.is_lazy ? this.lazy_rows : this.rows.length;
            })
            .catch(err => {
                console.error(err);
            })
            .finally(() => {
                this.loading = false;
                this.$nextTick(() => {
                    this.setupInfiniteScroll();
                    this.autofillLazyRows();
                });
            });
    },
    beforeUnmount() {
        if (this._scrollContainer) {
            this._scrollContainer.removeEventListener('scroll', this.onTableScroll);
        }
    },
    watch: {
        rows() {
            this.displayedCount = this.is_lazy ? this.lazy_rows : this.rows.length;
            this.$nextTick(() => {
                this.setupInfiniteScroll();
                this.autofillLazyRows();
            });
        },
    },
    methods: {
        setupInfiniteScroll() {
            if (!this.is_lazy) return;

            const scrollContainer = this.$refs.dt?.$el?.querySelector('.p-datatable-table-container');
            if (!scrollContainer) return;

            if (this._scrollContainer && this._scrollContainer !== scrollContainer) {
                this._scrollContainer.removeEventListener('scroll', this.onTableScroll);
            }

            if (this._scrollContainer !== scrollContainer) {
                this._scrollContainer = scrollContainer;
                this._scrollContainer.addEventListener('scroll', this.onTableScroll);
            }
        },
        onTableScroll(e) {
            const el = e.target;
            const threshold = 160;
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - threshold) {
                this.loadMore();
            }
        },
        loadMore() {
            if (!this.is_lazy || this.loadingMore || this.displayedCount >= this.rows.length) return;
            this.loadingMore = true;
            this.displayedCount = Math.min(this.displayedCount + this.lazy_rows, this.rows.length);
            this.$nextTick(() => {
                this.loadingMore = false;
                this.autofillLazyRows();
            });
        },
        autofillLazyRows() {
            if (!this.is_lazy || !this._scrollContainer) return;
            if (this.displayedCount >= this.rows.length) return;
            if (this._scrollContainer.scrollHeight <= this._scrollContainer.clientHeight + 10) {
                this.loadMore();
            }
        },

        aggiungiRiga(riga) {
            const nuovaRiga = {}
            this.sub_columns.forEach((col, index) => {
                if (typeof col.ref != 'undefined') {
                    nuovaRiga[col.name] = riga[col.ref];
                } else {
                    nuovaRiga[col.name] = '';
                }
            })
            riga.subrows.unshift(nuovaRiga);
            this.expandedRows[riga.id] = true;
            this.editingRows.push(nuovaRiga);
        },
        onRowEditSave: async function (event) {
            this.rows[this.rows.indexOf(event.data)] = event.newData;
            await axios.post(route(this.azioni['aggiorna'].url), event.newData);

        },
        onSubRowEditSave: async function (event, row_id) {
            const index = this.rows.findIndex(item => item.id === row_id);
            this.rows[index].subrows[event.index] = event.newData;
            await axios.post(route(this.sub_actions['aggiorna'].url), event.newData);
        },
        collapseAll() {
            this.expandedRows = [];
        },
        expandAll() {
            this.expandedRows = this.displayedRows.reduce((acc, row) => {
                acc[row.id] = true;
                return acc;
            }, {});

        },
        generateUrl(action, rowData) {
            const params = action.parametri.reduce((acc, param) => {
                acc[param] = rowData[param];
                return acc;
            }, {});

            if (action.url === '/redirect_appalto') {
                return "https://app-alto.it/"
            }

            return (action.url !== '#') ? route(action.url, params) : '';
        },
        handleHeaderAction(action) {
            if (action.url) {
                window.location.href = route(action.url, action.parametri);
            }
        },
        handleActionClick(action, data) {
            if (action.eventclick && action.eventclick !== '') {
                this.$emit(action.eventclick, {action, data});
            }
            if (action.url === '/redirect_appalto') {
                window.open("https://app-alto.it/", "_blank", "noopener,noreferrer");
            }
            if (!action.eventclick && action.url !== '/redirect_appalto') {
                window.location.href = this.generateUrl(action, data)
            }
        },
        getDynamicProperty(data, property) {
            return data[property];
        },
        formatDate(date) {
            if (!date) return '';
            if (date.includes('/')) {
                const [day, month, year] = date.split('/');
                return `${day}/${month}/${year}`;
            }
            return date;
        },
        formatMultiSelectId(row,column){


            return column.options.filter(option => row[column.name].includes(option.id))
                .map(option => option.nome)
                .join(', ');
        },
        clearFilter() {
            this.initFilters();
        },
        component(name) {
            return resolveComponent(name.component);
        },
        componentProps(name) {
            const rawProps = toRaw(name.props ?? {});
            for (const [key, value] of Object.entries(rawProps?.functions ?? {})) {
                rawProps[key] = new Function(value);
            }
            return rawProps;
        },
        rimuoviRiga: async function (action, elemento , level) {
            if (action.condizione === true && elemento[action.condizione_key] !== action.condizione_value) {
                alert(`${this.$root.trans.impossibile_eliminare} ${elemento.nome ?? ` ${this.$root.trans.l_elemento_selezionato}`}: ${this.$root.trans.tipologia_con_sottotipi_o_ticket}`)
                return
            }
            if (confirm(`${this.$root.trans.eliminare} ${elemento.nome ?? ` ${this.$root.trans.l_elemento_selezionato}`} ?`)) {
                const params = action.parametri.reduce((acc, param) => {
                    acc[param] = elemento[param];
                    return acc;
                }, {});
                const response = await axios.post(route(action.url, params));
                if (response.status == 200) {
                    if(level === 0){
                        this.rows.splice(this.rows.indexOf(elemento), 1);
                    }else{
                        const index = this.rows.findIndex(row => row.id === elemento.assenzegruppo_id);
                        this.rows[index].subrows.splice(this.rows[index].subrows.indexOf(elemento), 1);
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: `${elemento.nome ?? this.$root.trans.elemento} ${this.$root.trans.eliminato}`,
                        detail: `${elemento.nome ?? this.$root.trans.elemento} ${this.$root.trans.eliminato} ${this.$root.trans.correttamente}`,
                        life: 3000
                    })
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: `${response.status}`,
                        detail: `${this.$root.trans.elemento}: ${elemento.nome ?? this.$root.trans.elemento} `,
                        life: 3000
                    })
                }
            }
        },
        initFilters() {
            this.filters = {
                global: {value: null, matchMode: FilterMatchMode.CONTAINS}
            };

            this.columns.forEach(column => {
                if (column.filtro !== false) {
                    if (column.formato === 'data' || column.formato === 'dataora') {
                        this.filters[column.name] = {
                            operator: FilterOperator.AND,
                            constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]
                        };
                    } else {
                        this.filters[column.name] = {
                            operator: FilterOperator.AND,
                            constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
                        };
                    }
                }
            });
        },
    }
}

</script>
